/* eslint-disable @typescript-eslint/no-require-imports */
import { Platform } from 'react-native';

const PrivacyPolicyScreen =
  Platform.OS === 'web'
    ? require('./privacy-policy.web').default
    : require('./privacy-policy.native').default;

export default PrivacyPolicyScreen;
